import {APPOINTMENTS_SITE_FETCHED, SITE_CREATED, SITE_FETCHED, SITES_FETCHED} from "./actionType";
import {Dispatch} from "redux";
import {api} from "../../../api/api";
import {Action} from "redux-actions";
import {OnFailure, OnSuccess, OnSuccessData} from "../actionHelpers";
import SiteData from "../../../model/site/SiteData";
import Site from "../../../model/site/Site";
import {SitesMap} from "../../reducer/site/SiteState";

/**
 * Site creation successful action.
 * @param {Site} site Created site.
 * @returns {Action<SITE_CREATED>}
 */
export function siteCreated(site: Site): Action<SITE_CREATED> {
	return {type: SITE_CREATED, payload: {site}};
}

/**
 * Sites fetched successful action.
 * @param {SitesMap} sites
 * @returns {Action<SITES_FETCHED>}
 */
export function sitesFetched(sites: SitesMap): Action<SITES_FETCHED> {
	return {type: SITES_FETCHED, payload: {sites}};
}

/**
 * Site fetched successful action.
 * @param {Site} site.
 * @returns {Action<SITE_FETCHED>}
 */
export function siteFetched(site: Site): Action<SITE_FETCHED> {
	return {type: SITE_FETCHED, payload: {site}};
}

/**
 * Sites fetched successful action.
 * @param {SitesMap} sites
 * @returns {Action<APPOINTMENTS_SITE_FETCHED>}
 */
export function appointmentsSitesFetched(sites: SitesMap): Action<APPOINTMENTS_SITE_FETCHED> {
	return {type: APPOINTMENTS_SITE_FETCHED, payload: {sites}};
}

/**
 * Create site action.
 */
export function createSite(site: SiteData, onSuccess: OnSuccessData<Site>, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.siteApi.createSite(site).then((site: Site) => {
			onSuccess(site);
			dispatch(siteCreated(site))
		}).catch(onFailure);

	}
}

/**
 * Fetch all sites.
 */
export function fetchSites(onSuccess: OnSuccess, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.siteApi.fetchSites().then((sites: SitesMap) => {
			dispatch(sitesFetched(sites));
			onSuccess();
		}).catch(onFailure);

	}
}

/**
 * Fetch all sites.
 */
export function fetchSite(siteId: string, onSuccess: OnSuccess, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.siteApi.fetchSite(siteId).then((site) => {
			dispatch(siteFetched(site));
			onSuccess();
		}).catch(onFailure);

	}
}